<template>
    <div class="modal fade" id="costumModalresume" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">DATA AGENDA</span>
                        <span v-else>AGENDA DATA</span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <div class="card" style="padding: 20px;min-height: 90vh !important; height: 90vh !important;"
                            v-if="(bahasa === null) || (bahasa == 'ina')">
                            <span>Nama Agenda: {{ agenda }}</span>
                            <span>Topik Agenda: {{ topik }}</span>
                            <span>Mulai: {{ G_formatDateNonWIB(mulaiagenda) }}, {{ waktumulai }} WIB</span>
                            <span>Selesai: {{ G_formatDateNonWIB(selesaiagenda) }}, {{ waktuselesai }} WIB</span>
                            <span>Pelaksana: {{ pelaksana }}</span>
                            <span>Deskripsi Agenda:</span>
                            <span v-html="keterangan">
                            </span>
                            <span v-if="filenya_dokumen != ''">
                                <a :href="event_pdf + filenya_dokumen" target="_blank">
                                    Lihat Lampiran File
                                </a>
                            </span>
                            <span v-if="filenya_name != ''">
                                <img class="w-50 h-50" v-if="filenya_name != ''" :src="event_foto + filenya_name"
                                    alt="user image">
                            </span>
                        </div>
                        <div class="card" style="padding: 20px;min-height: 90vh !important; height: 90vh !important;"
                            v-else>
                            <span>Agenda Name: {{ agenda_eng }}</span>
                            <span>Agenda Topics: {{ topik_eng }}</span>
                            <span>Start: {{ G_formatDateNonWIB(mulai) }}, {{ waktumulai }} WIB</span>
                            <span>Finished: {{ G_formatDateNonWIB(selesai) }}, {{ waktuselesai }} WIB</span>
                            <span>PIU: {{ pelaksana }}</span>
                            <span>Agenda Description:</span>
                            <span v-html="keterangan_eng">
                            </span>
                            <span v-if="filenya_dokumen != ''">
                                <a :href="event_pdf + filenya_dokumen" target="_blank">
                                    View File Attachments
                                </a>
                            </span>
                            <span v-if="filenya_name != ''">
                                <img class="w-50 h-50" v-if="filenya_name != ''" :src="event_foto + filenya_name"
                                    alt="user image">
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalresume()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <div id="modal-content">
            <div class="col-sm-12">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">DATA AGENDA</span>
                <span v-else>AGENDA DATA</span>
            </div>

        </div>
    </div>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">KALENDER ACARA</span>
                <span v-else>EVENT CALENDAR</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">KALENDER ACARA</span>
                    <span v-else>EVENT CALENDAR</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="row p-3">
        <div class="col-sm-8 wow fadeInRight" data-wow-delay="0.3s">
            <div class="card card-info"
                style="min-height: 110vh !important; max-height: 110vh !important; height: 110vh !important;background-color: #ffffff;">
                <div class="rounded h-100">
                    <input type="hidden" class="form-control form-control-sm" id="detail" name="detail"
                        placeholder="Detail">
                    <button type="button" class="btn btn-tool" id="details" @click="details()" style="display: none;"><i
                            class="fas fa-minus text-white"></i></button>
                    <iframe :src="sourcenya" class="col-sm-12 text-center" style="max-height: 110vh;min-height: 110vh;"
                        frameborder="0" id="maps" scrolling="no" @load="loadpeta()"></iframe>
                </div>
            </div>
        </div>
        <div class="col-sm-4 wow fadeInRight text-justify" data-wow-delay="0.3s">
            <div class="card card-primary"
                style="min-height: 110vh !important; max-height: 110vh !important; height: 110vh !important;background-color: #ffffff;">
                <div class="card-header border-transparent text-center" style="background-color: #2176e6;border-top-left-radius: 10px !important;border-top-right-radius: 10px !important;">
                    <label>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Daftar agenda proyek
                            NUFReP:</span>
                        <span v-else>List of NUFReP project agendas:</span>
                    </label>
                    <br></br>
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Jumlah Data Agenda:</span> <span v-else>Number
                        of News agendas:</span> {{ G_numFormat(jumlahdata) }}
                    <br></br>
                    <span class=" text-center">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Halaman ke: </span> <span v-else>Page no:
                        </span><select v-model="halaman" @change="onChangeHalaman($event)">
                            <option v-for="index in jumlahhalaman" :key="index">
                                {{ index }}</option>
                        </select> <span v-if="(bahasa === null) || (bahasa == 'ina')"> dari </span> <span v-else> from
                        </span> {{ jumlahhalaman }}
                    </span>
                    <div class="col-sm-11 float-left p-2 wow fadeInRight">
                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                            placeholder="Masukkan Kata Kunci Pencarian / Enter Search Keywords" @keyup="ambildata()">
                    </div>
                    <div class="col-sm-1 float-left p-2 wow fadeInRight">
                        <button type="button" class="btn btn-success3 btn-sm text-white" @click="ambildata()"
                            data-toggle="tooltip" data-placement="left" title="Cari data..">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
                <div class="dropdown-divider"></div>
                <div class="card-body" style="overflow: auto;max-height: 80vh;">
                    <div class="row">
                        <div class="col-sm-12 float-left p-2 wow fadeInRight">
                            <div class="timeline-item p-2" style="font-size: smaller !important;"
                                v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                <span class="time" style="text-wrap: balance;"><i class="fas fa-clock"></i>
                                    {{ G_formatDateNonWIB(datalist.mulai) }} - {{ G_formatDateNonWIB(datalist.selesai)
                                    }}
                                </span>
                                <span class="timeline-header no-border text-primary dropdown-item"> <a
                                        href="javascript:void(0)" @click="pilihdetail(datalist.id)">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')"
                                            style="text-wrap: balance;">{{
                                                datalist.agenda }} </span>
                                        <span v-else style="font-size: x-small;text-wrap: balance;">{{
                                            datalist.agenda_eng }}</span>
                                    </a>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')" style="text-wrap: balance;">
                                        - {{ datalist.topik }}
                                    </span>
                                    <span v-else style="font-size: x-small;text-wrap: balance;"> - {{ datalist.topik_eng
                                    }}</span>
                                    <span class="text-success" style="font-size: x-small;text-wrap: balance;"><br>
                                        {{ datalist.lokasi }}
                                    </span>
                                </span>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->

    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import CryptoJS from 'crypto-js';

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bulan: new Date().getMonth() + 1,
            bahasa: localStorage.getItem("bahasasistem"),
            sourcenya: '',
            konten: '',
            datapesan: '',
            datamaster: [],
            datanya: [],
            carikata: '',
            sourcenya: '',
            linknya: process.env.VUE_APP_URL_API,
            folder_foto: process.env.VUE_APP_URL_API + 'maps_parastapainnovation_foto-Foto?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            agenda: '',
            agenda_eng: '',
            mulaiagenda: '',
            selesaiagenda: '',
            waktumulai: '',
            waktuselesai: '',
            pelaksana: '',
            topik: '',
            topik_eng: '',
            keterangan: '',
            keterangan_eng: '',
            filenya_dokumen: '',
            filenya_name: '',
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            event_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_event-Dokumentasi?f=',
            event_pdf: process.env.VUE_APP_URL_API + 'parastapainnovation_event-PDF?f=',
        };
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        tutupmodalresume() {
            $('#costumModalresume').modal('hide');
        },
        loadpeta() {
            this.halamanloading = true;
            const message = this.linknya + '_' + this.project_id;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/calendar.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
        async pilihdetail(kode) {
            var kodeagenda = kode;
            const mainAPINew = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            mainAPINew.get("parastapainnovationagenda-GetData?random=" + random + "&id=" + kodeagenda + "&project_id=" + this.project_id + "&cari=" + this.carikata).then(
                Response => {
                    this.datanya = [];
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datanya = Response.data.content.data;
                        this.agenda = Response.data.content.data[0].agenda;
                        this.agenda_eng = Response.data.content.data[0].agenda_eng;
                        this.topik = Response.data.content.data[0].topik;
                        this.topik_eng = Response.data.content.data[0].topik_eng;
                        this.pelaksana = Response.data.content.data[0].pengelola;
                        this.mulaiagenda = Response.data.content.data[0].mulai;
                        this.selesaiagenda = Response.data.content.data[0].selesai;
                        this.waktumulai = Response.data.content.data[0].waktumulai;
                        this.waktuselesai = Response.data.content.data[0].waktuselesai;
                        this.keterangan = atob(Response.data.content.data[0].permasalahan);
                        this.keterangan_eng = atob(Response.data.content.data[0].permasalahan_eng);
                        this.filenya_dokumen = Response.data.content.data[0].filenya_dokumen;
                        this.filenya_name = Response.data.content.data[0].filenya_name;

                        //var modal = document.getElementById("myModal");
                        $('#costumModalresume').modal('show');

                    }
                    else {
                        this.datapesan = "";
                        this.datanya = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        async details() {
            var kodeagenda = document.getElementById("detail").value;
            const mainAPINew = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            mainAPINew.get("parastapainnovationagenda-GetData?random=" + random + "&id=" + kodeagenda + "&project_id=" + this.project_id + "&cari=" + this.carikata).then(
                Response => {
                    this.datanya = [];
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datanya = Response.data.content.data;
                        this.agenda = Response.data.content.data[0].agenda;
                        this.agenda_eng = Response.data.content.data[0].agenda_eng;
                        this.topik = Response.data.content.data[0].topik;
                        this.topik_eng = Response.data.content.data[0].topik_eng;
                        this.pelaksana = Response.data.content.data[0].pengelola;
                        this.mulaiagenda = Response.data.content.data[0].mulai;
                        this.selesaiagenda = Response.data.content.data[0].selesai;
                        this.waktumulai = Response.data.content.data[0].waktumulai;
                        this.waktuselesai = Response.data.content.data[0].waktuselesai;
                        this.keterangan = atob(Response.data.content.data[0].permasalahan);
                        this.keterangan_eng = atob(Response.data.content.data[0].permasalahan_eng);
                        this.filenya_dokumen = Response.data.content.data[0].filenya_dokumen;
                        this.filenya_name = Response.data.content.data[0].filenya_name;

                        $('#costumModalresume').modal('show');
                    }
                    else {
                        this.datapesan = "";
                        this.datanya = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationagenda-GetList?random=" + random + "&project_id=" + this.project_id + "&cari=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.halamanloading = false;
            });
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationagenda-GetList?random=" + random + "&halaman=" + halamannya + "&project_id=" + this.project_id + "&cari=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                console.log(error);
                this.jumlahdata = 0;
                this.jumlahhalaman = 0;
                this.mulai = 0;
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>